// TODO: Delete `logoImgSrc` after homepage migration to Chakra

export const quotes = [
  {
    name: 'Zack Sheppard',
    role: 'Freelance Senior Software Developer',
    width: 500,
    text: `Clerk was suspiciously easy to use. Compared to its monstrously complicated competitors like Auth0 and Cognito, Clerk's blend of power, ease, and beauty is almost suspicious.`
  },
  {
    profileImgSrc: '/avatars/david.webp',
    name: 'David Price',
    role: 'RedwoodJS Cofounder',
    width: 685,
    logoImgSrc: 'redwoodjslogo',
    logoSrc: '/images/logos/redwood.svg',
    text: `Clerk setup and Dashboard DX are SilkySmooth™ and left a great impression. It’s feature-rich and includes MFA, but none of that gets in the way of usability. I have no hesitation recommending developers give it a go — it’s as simple as typing 'redwood setup auth clerk'.`
  },
  {
    profileImgSrc: '/avatars/aditya.webp',
    name: 'Aditya Agrawal',
    role: 'Early Facebook, CTO Dropbox',
    width: 500,
    logoImgSrc: 'facebooklogo',
    logoSrc: '/images/logos/facebook.svg',
    text: 'Working on account.php at Facebook was like being in a landmine field, and I love that Clerk’s User Profile solves that.'
  },
  {
    name: 'Abhijay Srivastava',
    role: 'Freelance Senior Software Developer',
    width: 400,
    text: `Even a non-tech guy can build its "authentication" portion with super ease!`
  },
  {
    profileImgSrc: '/avatars/guillermo.jpeg',
    name: 'Guillermo Rauch',
    role: 'CEO, Vercel',
    width: 500,
    logoImgSrc: 'vercellogo',
    logoSrc: '/images/logos/vercel.svg',
    text: 'Really good stuff. The Next.js integration story is already really quite good and the Clerk team has really good ideas on how to make it even better and more seamless.'
  },
  {
    profileImgSrc: '/avatars/sam.webp',
    name: 'Sam Bhagwat',
    role: 'Gatsby Cofounder',
    width: 450,
    logoImgSrc: 'gatsbylogo',
    logoSrc: '/images/logos/gatsby.svg',
    text: `Easy to use. Clerk's drop-in components make it straightforward to add authentication to your Gatsby site.`
  },
  {
    profileImgSrc: '/avatars/kent-c-dodds.jpeg',
    name: 'Kent C. Dodds',
    role: 'Remix Cofounder',
    width: 450,
    logoImgSrc: 'remixlogo',
    logoSrc: '/images/logos/remix.svg',
    text: `Integrating user auth with a bunch of providers is always an annoying part of building a web app. I'm impressed with how quickly you can get up and running and how well things work together with Clerk, Fauna, and Remix.`
  },
  {
    name: 'James Kienle',
    role: 'Frontend Lead',
    width: 580,
    text: `Gave 
        @ClerkDev
         a try today and had auth completely integrated in a new Next.js app in under an hour. Mad respect to the development team, this is an absolute game changer for auth and I can’t wait to see the company grow.`
  },
  {
    name: 'Mathias Lafeldt',
    role: 'Grafbase Founding Engineer',
    width: 500,
    profileImgSrc: '/avatars/mathias-lafeldt.jpeg',
    logoSrc: '/images/logos/logo-grafbase.svg',
    text: `Managed to integrate AppSync with 
    @ClerkDev
     over the weekend. Implementing a Lambda authorizer with Clerk's Go SDK was super easy.`
  },
  {
    name: 'Paul Copplestone',
    role: 'Supabase Cofounder',
    profileImgSrc: '/avatars/paul-copplestone.jpeg',
    width: 500,
    logoSrc: '/images/logos/supabase.svg',
    text: `Clerk’s integration gives Supabase developers another incredible option for handling authentication. And the Clerk team are a pleasure to work with.`
  }
  // {
  //   profileImgSrc:
  //     'https://media-exp1.licdn.com/dms/image/C4D03AQE4KG6dPJy9MA/profile-displayphoto-shrink_400_400/0/1516266848934?e=1651708800&v=beta&t=SGYyHU4uXzEbP0JOpkVhvWYOrEbkc2Q9g8u7Qs6iz7s',
  //   name: 'Simon Palmer',
  //   width: 500,
  //   text: `I have been in s/w for almost 30 years and have implemented at least 5 enterprise User Management systems for different companies. Clerk has just catapulted my latest startup project ahead by probably 6 months.`,
  // },
];
